import { useMutation } from "@apollo/client";
import { useContext, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_COUNCIL_POSITION } from "../../../Schema/CouncilPositions";

export const useDeleteCouncilPositions = ({ handleClose, setRefetch }) => {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteCouncilPositions] = useMutation(DELETE_COUNCIL_POSITION, {
    onCompleted: ({ deleteCouncilPositions }) => {
      setLoading(false);
      if (deleteCouncilPositions?.isSuccess === true) {
        setAlert(true, "success", deleteCouncilPositions?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteCouncilPositions?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = (id) => {
    deleteCouncilPositions({
      variables: {
        id: id,
      },
    });
  };

  return { handleDelete, loading };
};
